import { Component, OnInit, OnChanges, Input } from "@angular/core";
import { DataService } from "../../data.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "lc-login-user",
  templateUrl: "./login-user.component.html",
  styleUrls: ["./login-user.component.scss"],
})
export class LoginUserComponent implements OnInit, OnChanges {
  @Input() page: string = "";
  @Input() redirect_to: string = "/";
  @Input() mode: string = "login";
  returnUrl: string; // return to this url if it exists after login

  user_code: string;
  user_code_type: string = "action"; // 'action or 'zip'

  user_code_po: string;
  user_code_ph: string;

  show_aanmeld_popup: boolean = false;

  @Input("email") user_email: string;
  user_passwd: string;

  remember_me: boolean = false;

  new_user: any = {};
  login_error: boolean;
  login_error_x: any;
  try_logging_in = false;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.returnUrl =
      this.route.snapshot.queryParams["returnUrl"] || this.redirect_to;
  }

  ngOnChanges(changes) {
    if (!!this.dataService.tryLogin()) {
      let refresh_token = window.localStorage.getItem("user_refresh_token");
      let tt = atob(refresh_token).split("::");
      this.login(tt[0], tt[1]);
    }
  }

  show_popup(type?: string) {
    this.show_aanmeld_popup = true;
  }

  close_popup(type?: string) {
    this.show_aanmeld_popup = false;
  }

  // this function takes the user code and sets user status. Returns a result or error from the server
  check_code(code: string) {
    this.dataService.getUserForCode(code).subscribe(
      (client) => {
        // console.log(client);
        if (!!client.error) {
          if (this.user_code_type == "zip") {
            this.dataService.presentMessage(
              "Deze combinatie is niet bij ons bekend.",
              "error"
            );
          } else {
            this.dataService.presentMessage(
              "Oeps. Het lijkt erop dat deze actiecode niet bestaat.",
              "error"
            );
          }
        } else {
          // this.user_info = client;
          this.dataService.user_info = client;
          this.goToShop(); // we know the user now, let's forward.
          this.dataService.saveUserInfo(this.dataService.subuser_info);
          if (!!client.language && !this.new_user.language) {
            this.new_user.language = client.language;
            this.dataService.set_language(client.language.toLowerCase());
          }
        }
      },
      (err) => {
        this.dataService.presentMessage(
          "Oeps. Het lijkt er op dat er iets mis is gegaan bij het controleren van de code. Weet je zeker dat de code juist is?",
          "error"
        );
      },
      () => {
        console.debug("done getting code information");
      }
    );
  }

  login(email, password) {
    let email_lw = email.toLowerCase();
    this.try_logging_in = true;
    this.dataService.login(email_lw, password).subscribe(
      (subuser) => {
        try {
          window["track_event"]({ name: "user_login" });
        } catch (e) { }

        try {
          let date = new Date(subuser.token_valid_until);
          // the token date is an UTC date convert it to local date ...

          let valid_local_date = new Date(
            Date.UTC(
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              date.getHours(),
              date.getMinutes(),
              date.getSeconds()
            )
          );
          subuser.token_valid_until_date = valid_local_date;
        } catch (e) {
          console.warn("error converting date");
        }

        this.dataService.subuser_info = subuser;
        this.dataService.is_logged_in = true;
        this.try_logging_in = false; // done with this attempt
        this.dataService.presentMessage("U bent nu ingelogd", "success");

        if (!!this.dataService.subuser_info.verified) {
          window.localStorage.setItem("user_token", subuser.token);
          window.localStorage.setItem(
            "user_token_valid_until",
            subuser.token_valid_until_date.toString()
          );
          if (this.remember_me) {
            let refresh_token = btoa(`${email_lw}::${password}`);
            window.localStorage.setItem("user_refresh_token", refresh_token);
          }
        }

        // store user for page refresh etc.
        this.dataService.saveUserInfo(subuser);
        this.check_code(subuser.parent);

        this.login_error = false;

        if (!this.dataService.subuser_info.verified) {
          this.shouldVerify();
        }
      },
      (error) => {
        // debugger;
        console.error(error);
        const err = error.json();
        let mess = "Het inloggen is mislukt, probeer het nogmaals";
        let title = "error";
        try {
          if (!!err.message) {
            mess = err.message;
          }
          if (!!err.url) {
            this.login_error_x = { ...err, message: 'Your account has been migrated to a new Philips Store for business for which you should have received a new log in via email. In the event you did not receive it or cannot access the store, please contact our customer care team on 1300 314 263 (Monday to Friday from 9.00am to 5.00pm)' };
            // setTimeout(()=>{
            //   window.location.href = err.url;
            // }, 5000);
          }
        } catch (error2) {
          console.debug(error2);
        }
        this.login_error = true;
        this.dataService.is_logged_in = false;
        if (!err.url) this.dataService.presentMessage(mess, title, -1);
        this.try_logging_in = false; // it went wrong, let user try again
      }
    );
  }

  goToShop() {
    this.router.navigateByUrl(this.returnUrl);
  }

  shouldVerify() {
    this.mode = "verify";
  }

  showResetForm() {
    try {
      window["track_event"]({
        name: "interaction",
        description: "forgot_password",
      });
    } catch (e) { }
    this.mode = "reset";
  }

  onResetClose(event) {
    if (event) this.mode = "login"; // we hide the resetform now
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/login-user/login-user.component.ts